import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false
  },
  fonts: {
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif"
  },
  colors: {
    brand: {
      dark: '#0d1a12',
      card: '#132a1c',
      border: '#1e3a28',
      green: '#10b981',
      greenHover: '#059669',
      light: '#ecfdf5'
    }
  },
  styles: {
    global: {
      'html, body': {
        bg: '#050a07',
        color: '#f8fafc',
        fontFamily: "'Inter', sans-serif"
      },
      '::selection': {
        bg: 'rgba(16, 185, 129, 0.3)',
        color: '#fff'
      }
    }
  },
  shadows: {
    glow: '0 0 40px -10px rgba(16, 185, 129, 0.3)',
    'glow-strong': '0 0 50px -5px rgba(16, 185, 129, 0.5)'
  }
});

export { theme };